import { render, staticRenderFns } from "./Reference.vue?vue&type=template&id=a222185e&scoped=true"
import script from "./Reference.vue?vue&type=script&lang=js"
export * from "./Reference.vue?vue&type=script&lang=js"
import style0 from "./Reference.vue?vue&type=style&index=0&id=a222185e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a222185e",
  null
  
)

export default component.exports